import { FC } from 'react'
import FormSelect from '../elements/FormSelect'
import { useStoreActions, useStoreState } from '@/store'
import { AgentSearchCriteria } from '@/types/agents'
import generics from '@/utils/generics'

interface Props {
  className?: string
}

const sortByOptions = [
  { label: 'No. of closings in this area', value: 'transactions' },
  { label: 'Years of experience', value: 'experience' }
]

const SortBy: FC<Props> = ({ className = '' }) => {
  const { sort_by } = useStoreState(state => state.search.dimensions)
  const { setDimensions } = useStoreActions(actions => actions.search)
  const { onInputTracking, resetEvents } = useStoreActions(
    actions => actions.tracking
  )

  const sortByUpdateTracking = (
    value: 'experience' | 'transactions' | 'distance'
  ) => {
    const fieldInputtedPayload = generics.buildFieldInputtedPayload(
      'sortby',
      'Sort by',
      value
    )
    onInputTracking(fieldInputtedPayload)

    setDimensions({ sort_by: value })
  }

  return (
    <FormSelect
      options={sortByOptions}
      label="Sort by"
      name="sortBy"
      value={sort_by}
      onUpdate={(value: AgentSearchCriteria['sort_by']) =>
        sortByUpdateTracking(value)
      }
      className={className}
    />
  )
}

export default SortBy
